"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPersonalInformationComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("../../services/generic.content.service");
const router_1 = require("@angular/router");
const generic_content_service_2 = require("../../services/generic-content.service");
class CSPersonalInformationComponent {
    constructor(accountDetailService, modalService, genericContentService, accountService, genericContentServiceV2, router) {
        this.accountDetailService = accountDetailService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.genericContentServiceV2 = genericContentServiceV2;
        this.router = router;
        this.isSecondary = false;
        this.isProspect = false;
        this.stateList = [
            { name: 'Alabama', value: 'AL' },
            { name: 'Arkansas', value: 'AR' },
            { name: 'Florida', value: 'FL' },
            { name: 'Mississippi', value: 'MS' },
            { name: 'Tennessee', value: 'TN' }
        ];
    }
    open(content, options = { windowClass: 'dark-modal', centered: true }) {
        this.modelRef = this.modalService.open(content, options);
    }
    ngOnInit() {
        this.verifyMyAccountButton = '<button type="button" class="btn py-2 btn-outline-primary" role="button">Verify My Account Now</button>';
        this.getAccountInformationDetails();
        this.showForm = true;
        this.getErrorMessage();
        this.getGenericContent();
    }
    openNameChange() {
        this.open(this.nameModelContent);
    }
    editOrCancel() {
        this.showForm = !this.showForm;
        this.error = null;
        if (this.showForm) {
            this.personalInfo = JSON.parse(JSON.stringify(this.info));
        }
    }
    getAccountInformationDetails() {
        this.disabledEdit = true;
        this.loader = true;
        this.emailConfirmed = true;
        this.sentVerificationEmail = false;
        this.accountDetailService.getPersonalInformation().subscribe((accountInfo) => {
            this.info = JSON.parse(JSON.stringify(accountInfo));
            this.disabledEdit = false;
            this.loader = false;
            this.personalInfo = accountInfo;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
        this.accountService.getAccountDetails(false).subscribe((res) => {
            this.isProspect = res.prospectProfile;
            this.emailAddress = res.emailAddress;
            this.isBusinessAccount = res.businessAccount;
            if (!res.emailVerified && res.profileType === 'PRIMARY') {
                this.emailConfirmed = false;
            }
            if (res.profileType === 'SECONDARY') {
                this.isSecondary = true;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    submitPersonalInfo(value) {
        this.loader = true;
        this.error = null;
        this.accountDetailService.validatePersonalInformation(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.showForm = true;
            this.getAccountInformationDetails();
            this.EditForm = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    verifyEmailAddress(content) {
        this.pageLoader = true;
        this.accountService.sendVerifyEmailLink(content).subscribe((data) => {
            if (data.success === true) {
                this.pageLoader = false;
                this.sentVerificationEmail = true;
            }
        }, (err) => {
            this.error = err;
            this.pageLoader = false;
        });
    }
    showEmailVerification() {
        this.open(this.verifyEmailContent);
    }
    navigate() {
        if (this.isBusinessAccount) {
            location.href = '/my_account/personal/#/business/account-settings';
        }
        else {
            location.href = '/my_account/personal/#/wireless/account-settings';
        }
        this.modelRef.close();
    }
    onSubmitValidateCPNI(value) {
        this.personalInfoFormData = value;
        if (this.cpinRequired) {
            if (this.personalInfoFormData.email !== this.emailAddress) {
                this.openPopupModal(this.cpniModelContent);
            }
            else {
                this.submitPersonalInfo(this.personalInfoFormData);
            }
        }
        else {
            this.submitPersonalInfo(this.personalInfoFormData);
        }
    }
    verifyandSubmit(action) {
        this.modelRef.close();
        if (action === 'verify') {
            this.router.navigate(['/wireless/billing']);
        }
        else {
            this.submitPersonalInfo(this.personalInfoFormData);
        }
    }
    openPopupModal(content, options = { size: 'lg', windowClass: 'dark-modal', centered: true }) {
        this.modelRef = this.modalService.open(content, options);
    }
    getGenericContent() {
        const genericContentIds = [
            'genericCpniValidationWarning',
            '/generic/instructional/ChangeAccountName'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case 'genericCpniValidationWarning':
                        this.genericCpniValidationWarning = genericContent.content;
                        break;
                    case '/generic/instructional/ChangeAccountName':
                        this.accountChangeContent = genericContent.content;
                        break;
                    default:
                        break;
                }
            }
        }, (error) => { });
    }
}
exports.CSPersonalInformationComponent = CSPersonalInformationComponent;
//# sourceMappingURL=personalinformation.component.js.map